<template>
  <div class="iot">
    <div class="header">
      <div class="title">物联子系统</div>
      <div class="border"></div>
    </div>
    <div class="body">
      <div class="list">
        <router-link class="item" v-for="item in iotList" :key="item.id" :to="item.path">
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import mobileiot1 from "../../../../assets/product/mobileiot1.png";
import mobileiot2 from "../../../../assets/product/mobileiot2.png";
import mobileiot3 from "../../../../assets/product/mobileiot3.png";
import mobileiot4 from "../../../../assets/product/mobileiot4.png";
import mobileiot5 from "../../../../assets/product/mobileiot5.png";
import mobileiot6 from "../../../../assets/product/mobileiot6.png";
import mobileiot7 from "../../../../assets/product/mobileiot7.png";
import mobileiot8 from "../../../../assets/product/mobileiot8.png";

export default {
  setup() {
    return reactive({
      iotList: [
        {
          id: 1,
          title: "智能门禁",
          logo: mobileiot1,
          path: "/mobile/programme/accesscontrol",
        },
        {
          id: 2,
          title: "智能监控",
          logo: mobileiot2,
          path: "/mobile/programme/monitor",
        },
        {
          id: 3,
          title: "楼宇对讲",
          logo: mobileiot3,
          path: "/mobile/programme/intercom",
        },
        {
          id: 4,
          title: "智能梯控",
          logo: mobileiot4,
          path: "/mobile/programme/laddercontrol",
        },
        {
          id: 5,
          title: "智能家居",
          logo: mobileiot5,
          path: "/mobile/programme/homefurnishing",
        },
        {
          id: 6,
          title: "智能充电",
          logo: mobileiot6,
          path: "/mobile/programme/charge",
        },
        {
          id: 7,
          title: "智能停车",
          logo: mobileiot7,
          path: "/mobile/programme/parking",
        },
        {
          id: 8,
          title: "智能能耗",
          logo: mobileiot8,
          // path: "/mobile/programme/energyconsumption",
          path: ''
        },
      ],
    });
  },
};
</script>

<style scoped>
.iot {
  width: 100%;
  margin: 24px auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
  margin-top: 24px;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 4px auto 0;
}

.body .list {
  width: 92vw;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 16px;
}
.body .list .item {
  position: relative;
  margin-bottom: 10px;
}
.body .list .item img {
  width: 80px;
}
.body .list .item div {
  width: 52px;
  position: absolute;
  bottom: 15%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 13px;
  color: #2a3d50;
}
</style>
